import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../styles/Prescription.scss";
import PrescriptionTemplate from "./PrescriptionTemplate";
import { patientid } from "../Redux/Slice/rootSlice";
import PatientReportFileTemplateCreate from "./PatientReportFileTemplateCreate";
import BillGenerateTemplate from "./BillGenerateTemplate";

function BillGenerate(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const prescriptionType = useSelector(
    (state) => state.counter.prescriptionType
  );
  const patientId = useSelector((state) => state.counter.patientid);

  return (
    <>
      <div
        className={
          sideactive ? "maincontainer-patient-sa" : "maincontainer-patient"
        }
      >
        <div className="patient-header">
          <div className="row">
            <div className="col">
              <h3 className="page-title">Report Template</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a
                    href="/"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    Dashboard /
                  </a>
                  <a
                    href="/patientreports"
                    style={{ textDecoration: "none", color: "black" }}
                  >
                    &nbsp;Patient Reports
                  </a>
                </li>
                <li className="breadcrumb-item active">Report Template</li>
              </ul>
            </div>
          </div>
          <BillGenerateTemplate
            loaderchange={props.loaderchange}
            patientId={patientId}
            popupalert={props.popupalert}
            popuptext={props.popuptext}
          />
        </div>
      </div>
    </>
  );
}

export default BillGenerate;
